import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-logo-marquee',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './logo-marquee.component.html',
  styleUrls: ['./logo-marquee.component.scss']
})
export class LogoMarqueeComponent {}
